
import React from 'react';
import { useParams } from 'react-router-dom';
import { BotInfoCard } from '@/components/bot-detail/BotInfoCard';
import { ConnectionSettingsCard } from '@/components/bot-detail/ConnectionSettingsCard';
import { SignalHistorySection } from '@/components/bot-detail/SignalHistorySection';
import { ConnectedAccountsSection } from '@/components/bot-detail/ConnectedAccountsSection';
import { useBotDetail } from '@/hooks/use-bot-detail';
import { PageHeader } from '@/components/bot-detail/PageHeader';
import { Toaster } from 'sonner';

const BotDetailPage = () => {
  const { botId } = useParams<{ botId: string }>();
  const { 
    bot, 
    isLoading, 
    error, 
    connectedAccounts,
    toggleBotStatus,
    deleteBot,
    isDeleting,
    onToggleAccountConnection,
    onDeleteAccount
  } = useBotDetail(botId);

  if (error) {
    return (
      <div className="p-6 text-center">
        <h2 className="text-xl font-semibold text-destructive">Error</h2>
        <p className="mt-2">Failed to load bot details. Please try again later.</p>
      </div>
    );
  }

  return (
    <div className="space-y-8 pb-10">
      <Toaster position="top-right" />
      <PageHeader 
        bot={bot} 
        isLoading={isLoading}
        onBack={() => window.history.back()}
        onToggleStatus={toggleBotStatus}
        onDelete={deleteBot}
        isDeleting={isDeleting}
      />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left column - 2/3 width on large screens */}
        <div className="lg:col-span-2 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <BotInfoCard bot={bot} isLoading={isLoading} />
            <ConnectionSettingsCard bot={bot} isLoading={isLoading} />
          </div>
          
          <SignalHistorySection botId={botId} />
        </div>
        
        {/* Right column - 1/3 width on large screens */}
        <div>
          <ConnectedAccountsSection 
            accounts={connectedAccounts} 
            isLoading={isLoading}
            botId={botId}
            onToggleConnection={onToggleAccountConnection}
            onDeleteAccount={onDeleteAccount}
          />
        </div>
      </div>
    </div>
  );
};

export default BotDetailPage;
